export * from './baThemeSpinner.service';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/services/baThemeSpinner/index.ts